export const JobForm_Page_Data = {
    "bdm-international": {
        // Page Meta Fields
        META_PG_OG_Title: 'BDM - International | Callistus Blinds',
        META_PG_OG_Description: 'Having an experience of 5+ years in Sales & Marketing with exposure to International Business and Market.',
        META_PG_Canonical_OG_URL: 'https://callistusblinds.com/job/bdm-international/',

        Job_TITLE: "BDM – International",
        Job_DESCRIPTION: "Having an experience of 5+ years in Sales & Marketing with exposure to International Business and Market."
    },
    "dgm-international-business": {
        // Page Meta Fields
        META_PG_OG_Title: 'DGM - International Business - UAE | Callistus Blinds',
        META_PG_OG_Description: 'Having 10 + Years of experience in B2B Channel Sales specialised in Window Blinds Industry.',
        META_PG_Canonical_OG_URL: 'https://callistusblinds.com/job/dgm-international-business/',

        Job_TITLE: "DGM – International Business – UAE",
        Job_DESCRIPTION: "Having 10 + Years of experience in B2B Channel Sales specialised in Window Blinds Industry."
    },
    "bdm": {
        // Page Meta Fields
        META_PG_OG_Title: 'BDM - UK | Callistus Blinds',
        META_PG_OG_Description: 'Having an experience of 5+ years in Sales & Marketing with exposure to International Business and Market. Location: UK',
        META_PG_Canonical_OG_URL: 'https://callistusblinds.com/job/bdm/',

        Job_TITLE: "BDM – UK",
        Job_DESCRIPTION: "Having an experience of 5+ years in Sales & Marketing with exposure to International Business and Market.",
        Job_LOCATION: "UK"
    },
    "sales-manager": {
        // Page Meta Fields
        META_PG_OG_Title: 'Business Development Executive | Callistus Blinds',
        META_PG_OG_Description: 'Having an experience of 3+ years in Sales & Marketing with exposure to International Business and Market Location: India',
        META_PG_Canonical_OG_URL: 'https://callistusblinds.com/job/sales-manager/',

        Job_TITLE: "Business Development Executive",
        Job_DESCRIPTION: "Having an experience of 3+ years in Sales & Marketing with exposure to International Business and Market",
        Job_LOCATION: "India"
    },
    "hr-manager": {
        // Page Meta Fields
        META_PG_OG_Title: 'DGM – Sales/Marketing & Operations | Callistus Blinds',
        META_PG_OG_Description: '7 + years experience in Sales – Marketing & Operations with exposure to International Market. Location: UAE',
        META_PG_Canonical_OG_URL: 'https://callistusblinds.com/job/hr-manager/',

        Job_TITLE: "DGM – Sales/Marketing & Operations",
        Job_DESCRIPTION: "7 + years experience in Sales – Marketing & Operations with exposure to International Market.",
        Job_LOCATION: "UAE"
    }
}